import React, {useEffect, useState} from "react";
import Frame from "../common/Frame"
import Footer from "../common/Footer"
import {useTranslation} from "react-i18next"
import {appdata, save} from "../../logic_tmp/appdata/AppData"
import {MySpinner} from "../common/MySpinner";
import i18next from "i18next";
import {useHistory} from "react-router-dom";
import {getProfile} from "../../logic_tmp/storage/LgProfile";
import {createLead, pingApi} from "../../backend/connectors/JavaConnector";
import {registerConcersion} from "../../logic/funel/FacebookUtils";
import {cleanPhoneString, leadPageCalculateNextStep, validateEmailImpl, validatePhoneImpl} from "./LeadPageLogic";
import {calcNameOfConcert, calcWhere, prepareGeo, setCyrcleEnv} from "../lg/widgets/common/LgHelper";
import {getImpl, lgSetup} from "../../backend/LgSetup";
import {calcHeader, logPageOpened} from "../model/utils";
import { OrganizerInfo } from "../common/OrganizerInfo";
import {stringify} from "uuid";

export function LeadNew() {
    const [isLoading, setLoading] = useState(true);
    const {t} = useTranslation()
    const history = useHistory();
    const [name, setName] = useState(getProfile().customerName !== undefined ? getProfile().customerName : "")
    const [email, setEmail] = useState(getProfile().customerId !== undefined ? getProfile().customerId : "")
    const [phone, setPhone] = useState(getProfile().customerPhone !== undefined ? getProfile().customerPhone : "")
    const [locations] = useState(new Array())

    const [nameError, setNameError] = useState("")
    const [phoneError, setPhoneError] = useState("")
    const [emailError, setEmailError] = useState("")
    const [locationError, setLocationError] = useState("")

    const [error, setError] = useState("")
    const [busy, setBusy] = useState(false)
    pingApi().then()
    if(appdata.product["type"] === "SUBSCRIPTION" || appdata.product["type"] === "LEADGEN")
    {
        registerConcersion('AddToWishlist');
    }
    const handleSubmit = (event) => {
        event.preventDefault()
        if (validateEmail(email) & validateName(name) & (validatePhone(phone) || appdata.product.type === "SUBSCRIPTION" || appdata.product.type === "PDF") & (validateLocations(locations) || !isLeadGen())) {
            appdata.customerEmail = email
            appdata.customerName = name
            appdata.customerPhone = phone
            appdata.priceModel = appdata.product.priceModel
            if (isLeadGen()) {
                appdata.amount = 0
                appdata.count = 1
                appdata.countFull = 1
                appdata.utm_source = ""
                for (var i = 0; i < locations.length; i++) {
                    appdata.utm_source = appdata.utm_source + locations[i] + ",";
                }
            }
            save()
            registerConcersion('Lead');
            window.gtag('event', 'conversion', {'send_to': 'AW-457108933/-suYCIm3m8AYEMXb-9kB'});


            if (appdata.customerEmail === "skip@duoclassico.eu") {
                history.push(leadPageCalculateNextStep(appdata));
            } else
                saveLead();
        }
    }

    function saveLead() {
        setError("");
        if (busy) return;
        setBusy(true)
        if (appdata.product.eventStatus === "SOLD" && ! appdata.admin)
        {
            if (appdata.priceModel === "FLEX")
            {
                appdata.priceModel = "FIXED"
            }
        }
        createLead()
            .then(response => {
                if (response.status !== 200) {
                    setError(response.statusText);
                    return;
                }
                history.push(leadPageCalculateNextStep(appdata));
            })
            .catch((error) => {
                setError(error.message);
                return Promise.reject(error)
            })
            .finally(() => {
                setBusy(false);
            });
    }

    const handleNameChange = (event) => {
        validateName(event.target.value)
        setName(event.target.value)
    }
    const handleEmailChange = (event) => {
        validateEmail(event.target.value)
        setEmail(event.target.value)
    }
    const handlePhoneChange = (event) => {
        let phone = cleanPhoneString(event.target.value)
        validatePhone(phone)
        setPhone(phone)
    }

    function validateName(nameStr) {
        if (!nameStr || nameStr.trim().length === 0) {
            // @ts-ignore
            setNameError(t("PleaseEnterName"))
            return false;
        }
        setNameError("")
        return true;
    }

    function validateEmail(emailstr) {
        let res = validateEmailImpl(emailstr)
        if (res === "OK") {
            setEmailError("")
            return true;
        }
        setEmailError(t(res))
        return false
    }

    function validatePhone(phonestr) {
        let res = validatePhoneImpl(phonestr)
        if (res !== "OK") {
            setPhoneError(t(res))
            return false;
        }
        setPhoneError("")
        return true;
    }

    function isLeadGen() {
        return (appdata.action === "LEADGEN")

    }

    const handleLocationBoxChange = (event, city) => {
        if (event.target.checked)
            locations.push(city)
        else
            for (var i = 0; i < locations.length; i++) {

                if (locations[i] === city) {

                    locations.splice(i, 1);
                }

            }
        validateLocations(locations)

    }

    function validateLocations(locs) {
        if (locations.length < 1) {
            setLocationError(t("PleaseSelectAtLeastOneCity"))
            return false;
        }
        setLocationError("")
        return true;
    }

    let text2Key = "WeWillSendTicketOnThisEmail"
    if (appdata.leadSubAction === "SpecialProposal")
        text2Key = appdata.product["specialProposal"]["leadExplanationKey"]
    else if (appdata.product.type === "RECORDING")
        text2Key = "WeWillSendLinkOnThisEmailRecording"
    else if (appdata.product.type === "ONLINE")
        text2Key = "WeWillSendLinkOnThisEmailOnline"
    else if (appdata.product.type === "OFFLINE")
        text2Key = "WeWillSendLinkOnThisEmailOffline"
    else if (appdata.product.type === "DONATION")
        text2Key = "WeWillSendLinkOnThisEmailDonation"
    else if (appdata.product.type === "SUBSCRIPTION")
        text2Key = "WeWillSendUpdatesOnLrrh"
    else if (appdata.product.type === "LEADGEN")
        text2Key = "ThankYouPleaseEnterIWillProposeSpecialPrace"
    else if (appdata.product.type === "PDF")
        text2Key = "WeWillSendLinkOnThisEmailPdf"
    else if (appdata.product.type === "SERVICE")
        text2Key = ""


    else throw Error("Unsuported type" + appdata.product.type )

    calcHeader(t)

    useEffect(() => {
        logPageOpened(window.location.pathname,"Pay")
        if (isLeadGen()) {
            setCyrcleEnv(appdata, getProfile())
            prepareGeo(appdata).then(r => {
                    setLoading(false)
                }
            )
        } else
            setLoading(false)
    }, []);


    return (

        <div>
            {isLoading ? <div>...</div> :
                <Frame>
                    <div>
                        <div>
                            <form className="app-form" method="post" id="lead_form" onSubmit={handleSubmit}>
                                {isLeadGen() ?
                                    <div>
                                        <h2 className="offer-pay__title">
                                            Спасибо за интерес к концерту
                                            "{calcNameOfConcert(appdata)}"
                                        </h2>
                                        <h2>
                                            Мы собираемся организовать этот концерт в {calcWhere(appdata)}.
                                        </h2>
                                        <h2>
                                            Даты и места проведения уточняются.
                                        </h2>
                                        <h2>
                                            Оставьте здесь свои контактные данные и мы свяжемся с вами, когда места и
                                            даты
                                            определятся.
                                        </h2>
                                    </div>
                                    :
                                    <h2 className="app-title">
                                        {t("PleaseEnterNameAndEmail")}
                                        <br/>
                                        {t(text2Key)}
                                    </h2>
                                }
                                <br/>
                                <div>
                                    <input
                                        type="text"
                                        name="name"
                                        value={name}
                                        onChange={event => handleNameChange(event)}
                                        className="form-control"
                                        placeholder={t("Name")}
                                        id="name"/>
                                    <div className="text-danger">{nameError}</div>
                                </div>
                                <br/>
                                <div>
                                    <input
                                        type="text"
                                        name="email"
                                        value={email}
                                        onChange={event => handleEmailChange(event)}
                                        className="form-control"
                                        placeholder={t("EMail")}
                                        id="email"/>
                                    <div className="text-danger">{emailError}</div>
                                </div>
                                <br/>
                                {!(appdata.product.type === "SUBSCRIPTION" || appdata.product.type === "LEADGEN" || appdata.product.type === "PDF") ?
                                    <div>
                                    <input
                                        type="text"
                                        name="phone"
                                        value={phone}
                                        onChange={event => handlePhoneChange(event)}
                                        className="form-control"
                                        placeholder={t("Phone")}
                                        id="phone"/>
                                    <div className="text-danger">{phoneError}</div>
                                </div>:<div></div>}
                                {(!isLeadGen() && !(appdata.product.type === "DONATION") && !(appdata.product.type === "SUBSCRIPTION")  && !(appdata.product.type === "LEADGEN") && !(appdata.product.type === "PDF") && !(appdata.product.type === "SERVICE") && !(appdata.leadSubAction === "SpecialProposal") ) ?
                                    <label id="radiobox" className="label label_agree">
                                        <input
                                            type="radio"
                                            name="agreeWithConditions"
                                            value={true}
                                            onChange={() => {
                                            }}
                                            className="radio"
                                            id="agreeWithConditions" checked/>

                                        <span className="fake"/>
                                        <p className="radio__text">
                                            <a href={t("urlOfConditions")} className="radio__link">
                                                {t("AgreeWithConditions")}
                                            </a>
                                        </p>
                                    </label>
                                    : ""}
                                {isLeadGen() && appdata.geoCode !== "ANY" ?
                                    <div>
                                        <h2>
                                            В какие города вас приглашать?
                                        </h2>
                                        <div className="control-group">
                                            {appdata.geoData.pointsSorted.map((item) =>
                                                <label key={item.cityKey} className="control control-checkbox">
                                                    {getImpl(lgSetup.cities[item.cityKey], ["name"]) + " " +
                                                        (((item.distance.value / 1000) < 100) ? Math.floor((item.distance.value / 1000)) + "km." : "")
                                                    }
                                                    <input type="checkbox"
                                                           onChange={event => handleLocationBoxChange(event, item.cityKey)}/>
                                                    <div className="control_indicator" id={item.cityKey}></div>
                                                </label>
                                            )}
                                            <label className="control control-checkbox">
                                                Приглашайте во все!
                                                <input type="checkbox"
                                                       onChange={event => handleLocationBoxChange(event, "ALL")}/>
                                                <div className="control_indicator"></div>
                                            </label>
                                            <div className="text-danger">{locationError}</div>
                                        </div>
                                    </div> : <div></div>}


                                <p className="app-text">
                                    {error}
                                </p>
                                <div className="app-button d-flex justify-content-around">
                                    <button id="nextButton" type="submit"
                                            className="app-btn app-btn-further next-step-btn">
                                        {busy ? <MySpinner/> : <span>{t("NextButton")}</span>}
                                    </button>
                                </div>
                                <OrganizerInfo />
                            </form>
                        </div>
                    </div>
                    {appdata.cmp.purpose === "CONCERT"?
                    <Footer></Footer>:<div></div>}
                </Frame>
            }
        </div>
    )
}
